var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M165,0C74,0,0,74,0,165S74,330,165,330s165-74,165-165S256,0,165,0Zm0,300C90.56,300,30,239.44,30,165S90.56,30,165,30,300,90.56,300,165,239.44,300,165,300Z","key":0}),React.createElement("path",{"d":"M226.87,106.66,142,191.52l-38.89-38.89a15,15,0,1,0-21.21,21.21l49.49,49.5A15,15,0,0,0,142,227.73h0a15,15,0,0,0,10.6-4.39l95.47-95.46a15,15,0,1,0-21.22-21.22Z","key":1})]);
}

Check.defaultProps = {"viewBox":"0 0 330 330"};

module.exports = Check;

Check.default = Check;
